export default __webpack_public_path__ + "static/media/25.c17535dd.jpg";